import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ReportFilterSlice = createSlice({
  name: "ReportFilterSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ReportFilter: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successReportFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureReportFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearReportFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  ReportFilter,
  failureReportFilter,
  successReportFilter,
  clearReportFilter,
} = ReportFilterSlice.actions;

export default ReportFilterSlice.reducer;
